import { isEmpty } from 'lodash';

const getGiveawayStatusesResponse = (response) => {
  if (isEmpty(response?.data?.briefStatuses)) return [];

  const briefStatuses = response.data.briefStatuses.map((giveawayStatus) => {
    return {
      value: giveawayStatus?.key,
      label: giveawayStatus?.label,
    };
  });

  return briefStatuses;
};

export default getGiveawayStatusesResponse;
